import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebookF, FaInstagram, FaWhatsapp, FaMapMarkerAlt,
  FaPhoneAlt, FaEnvelope, FaClock, FaChevronRight
} from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { getCompanyInfo } from '../firebase/db';
import Logo from './Logo';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const [info, setInfo] = useState({
    name: 'Digvijay Industries',
    email: 'contact@digvijayindia.com',
    phone: '8956403388',
    address: 'J-79, MIDC, Kupwad, Sangli, Maharashtra - 416436',
    openingHours: '09.00 am to 06.00 pm | Weekly Off: Tuesday'
  });

  useEffect(() => {
    getCompanyInfo().then(data => {
      if (data) {
        if (data.phone) {
          data.phone = data.phone
            .split(',')
            .map(p => p.trim())
            .filter(p => !p.includes('2644484') && !p.includes('0233'))
            .join(', ') || '8956403388';
        }
        setInfo(data);
      }
    });
  }, []);

  const phoneList = (info.phone || '8956403388')
    .split(/[,/|]/)
    .map(p => p.trim())
    .filter(p => !p.includes('2644484') && !p.includes('0233') && p.length > 0);
  const phoneNumbers = phoneList.length > 0 ? phoneList : ['8956403388'];
  const whatsappUrl = `https://wa.me/918956403388?text=${encodeURIComponent(
    'Hello Digvijay Industries, I would like to inquire about your machinery and products. Please share more details.'
  )}`;

  return (
    <footer className="footer">
      <div className="container footer-container">

        {/* Col 1: About & Logo */}
        <div className="footer-col footer-col-about">
          <div className="footer-logo-wrapper">
            <Logo width="170px" height="52px" />
          </div>
          <p className="footer-desc">
            {t('footerAboutDesc')}
          </p>
          <div className="social-links">
            <a href="https://www.facebook.com/digvijayindustriesofficial/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://www.instagram.com/digvijay.industries" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram"><FaInstagram /></a>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="WhatsApp"><FaWhatsapp /></a>
          </div>
        </div>

        {/* Col 2: Quick Links */}
        <div className="footer-col">
          <h3 className="footer-title">{t('footerQuickLinks')}</h3>
          <ul className="footer-links">
            <li><Link to="/"><FaChevronRight className="link-arrow" /> {t('navHome') && t('navHome') !== 'navHome' ? t('navHome') : 'Home'}</Link></li>
            <li><Link to="/about"><FaChevronRight className="link-arrow" /> {t('navAbout')}</Link></li>
            <li><Link to="/products"><FaChevronRight className="link-arrow" /> {t('navProducts')}</Link></li>
            <li><Link to="/services"><FaChevronRight className="link-arrow" /> {t('navServices')}</Link></li>
            <li><Link to="/blogs"><FaChevronRight className="link-arrow" /> {t('navBlog')}</Link></li>
            <li><Link to="/contact"><FaChevronRight className="link-arrow" /> {t('navContact')}</Link></li>
          </ul>
        </div>

        {/* Col 3: Contact Info */}
        <div className="footer-col">
          <h3 className="footer-title">{t('footerContactInfo')}</h3>
          <ul className="footer-contact">
            <li>
              <div className="icon-box"><FaMapMarkerAlt /></div>
              <span>
                <a
                  href="https://maps.app.goo.gl/niM11jhKVZrqEdcc7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  {info.address}
                </a>
              </span>
            </li>
            <li>
              <div className="icon-box"><FaPhoneAlt /></div>
              <span>
                {phoneNumbers.map((phone, idx) => (
                  <React.Fragment key={idx}>
                    <a href={`tel:${phone.replace(/[^0-9+]/g, '')}`} className="contact-link">{phone}</a>
                    {idx < phoneNumbers.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </span>
            </li>
            <li>
              <div className="icon-box"><FaEnvelope /></div>
              <span>
                <a href={`mailto:${info.email}`} className="contact-link">{info.email}</a>
              </span>
            </li>
          </ul>
        </div>

        {/* Col 4: Opening Hours */}
        <div className="footer-col">
          <h3 className="footer-title">{t('footerOpeningHours')}</h3>
          <div className="opening-hours-card">
            <FaClock className="hours-icon" />
            <div className="hours-text">
              <strong>{t('footerTime')}</strong>
              <div className="hours-badge">{t('footerWeeklyOff')}</div>
            </div>
          </div>
        </div>

      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p className="copyright-text">
            &copy; {new Date().getFullYear()} <strong>{info.name}</strong>. {t('footerRights')}
          </p>
          <p className="developer-text">
            {t('footerDesignedBy')}{' '}
            <a
              href="https://sahyadritech.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="designer-link"
            >
              Sahyadri Tech
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
